import { Box, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";
import {
  OrderRequestBrokerType,
  OrderRequestBrokerTypeFarsi,
  OrderRequestState,
  OrderRequestStateFarsi,
  OrderRequestType,
  PurchaseMethod
} from "../../types/OrderRequestTypes";
import { ReactComponent as DebitBox } from "../../assets/icons/debit-box.svg";
import { ReactComponent as CreditBox } from "../../assets/icons/credit-box.svg";
import { useTheme } from "@emotion/react";
import moment from "moment-jalaali";

const Item = ({ title, value }) => {
  return (
    <Box
      sx={{
        mt: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="subtitle1" color="grey.4">
        {title}
      </Typography>
      <Typography variant="h6" color="grey.2">
        {value}
      </Typography>
    </Box>
  );
};

function OrderRequestCard({ sx = [], ...props }) {
  const { orderRequest } = props;
  const theme = useTheme();

  const getOrderRequestColor = (status) => {
    switch (status) {
      case OrderRequestState.CREATED:
      case OrderRequestState.PAID:
      case OrderRequestState.QUEUED:
      case OrderRequestState.UNKNOWN:
      case OrderRequestState.PENDING:
        return theme.palette.orange.main;
      case OrderRequestState.APPROVED:
        return theme.palette.primary.main;
      case OrderRequestState.DELETED:
      case OrderRequestState.REFUNDED:
        return theme.palette.red.main;
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        py: "16px",
        display: "flex",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        {orderRequest.requestType === OrderRequestType.SELL ? (
          <>
            <DebitBox width={24} height={24} />
            <Typography variant="subtitle1" color="grey.3">
              فروش
            </Typography>
          </>
        ) : (
          <>
            <CreditBox width={24} height={24} />
            <Typography variant="subtitle1" color="grey.3">
              خرید
            </Typography>
          </>
        )}
      </Box>
      <Box
        sx={{ ml: "24px", flex: 1, display: "flex", flexDirection: "column" }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" color="grey.2">
            {orderRequest.financialAsset.name}
          </Typography>
          <Typography
            variant="h5"
            color={getOrderRequestColor(orderRequest.state)}
          >
            {OrderRequestStateFarsi[orderRequest.state]}
          </Typography>
        </Box>

        {orderRequest.requestType !== OrderRequestType.SELL && orderRequest.purchaseMethod && (
          <Item
            title={"نوع سرمایه‌گذاری"}
            value={PurchaseMethod[orderRequest.purchaseMethod]}
          />
        )}
        {orderRequest.approvedAmount && (
          <Item
            title={"مبلغ تایید شده (تومان)"}
            value={toToman(orderRequest.approvedAmount)}
          />
        )}
        {orderRequest.requestedAmount && (
          <Item
            title={"مبلغ سفارش (تومان)"}
            value={toToman(orderRequest.requestedAmount)}
          />
        )}
        {orderRequest.unit &&
          <Item title={"تعداد واحد"} value={orderRequest.unit} />
        }
        <Item
          title={"تاریخ سفارش"}
          value={moment(orderRequest.requestTime).format("jYYYY/jMM/jDD")}
        />
        {orderRequest.registerTime && (
          <Item
            title={"تاریخ ثبت"}
            value={moment(orderRequest.registerTime).format("jYYYY/jMM/jDD")}
          />
        )}
        {orderRequest.approveTime && (
          <Item
            title={"تاریخ تایید"}
            value={moment(orderRequest.approveTime).format("jYYYY/jMM/jDD")}
          />
        )}
        {orderRequest.brokerType && orderRequest.brokerType == "OTHER" && (
          <Item
            title={"مرجع تراکنش"}
            value={OrderRequestBrokerTypeFarsi[orderRequest.brokerType]}
          />
        )}
      </Box>
    </Box>
  );
}

export default OrderRequestCard;
